import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../context/AppContext';
import colors from '../styles/colors';
import { DashboardFilteresTypes } from '../util/CustomerFilterEnum';
import { getFilteredContacts } from '../util/customersUtil';
import { Card, CardHeaderNumber } from './MetricsCard';
import analyticsKeys from "../util/UsageStatLinks";
import useMutateAnalytics from '../util/mutate.Analytics';
export default function ContactsWelcomedCard({ metrics, timeRange }) {
  const { setApp } = useContext(AppContext);
  const isClickable = metrics?.contactsWelcomed > 0;
  const onClickHandler = () => getFilteredContacts(setApp, history, {
    type: DashboardFilteresTypes.ContactsWelcomed,
    ...timeRange,
  });
   const mutateAnalytics = useMutateAnalytics()
  const history = useHistory();
  return (
    <Card title="Contacts Welcomed">
      <CardHeaderNumber
        color={isClickable ? colors.seaGreen : colors.grey2}
        onClick={isClickable ? () => {
          const mutateAnalyticsVariables = {
            link: analyticsKeys.DASHBOARD_CONTACT_WELCOMED,
          };
          mutateAnalytics(mutateAnalyticsVariables);
          onClickHandler();
        } : null}
      >
        {metrics?.contactsWelcomed.toString()}
      </CardHeaderNumber>
    </Card>
  );
}
